import { useState, memo } from 'react'
import { GridCell, GridCellProps } from '@mui/x-data-grid'
import { Tooltip } from '@mui/material'

import { toolTipCustomStyles } from 'components/Shared/Table/Constants'
import { isMobileView } from 'lib/GlobalConstants'

const TableCellWithToolTip = (props: GridCellProps) => {
  const { showTabelCellWithTooltip, children } = props || {}
  const intialToolTipState = { shouldTooltipOpen: false, text: '' }
  const [toolTipData, setToolTipVisibilty] = useState(intialToolTipState)

  const handleToolTipOpen = ({
    target,
  }: React.ChangeEvent<HTMLInputElement>) => {
    const { scrollWidth = 0, clientWidth = 0 } =
      //For the truncated text to show tooltip, we should ideally use the Typography Element
      target?.querySelector('.MuiTypography-root') || {}
    //for mobile view target actually points the Typography root element hence this condition
    const visibility = isMobileView
      ? target?.scrollWidth > target?.clientWidth
      : scrollWidth > clientWidth

    setToolTipVisibilty((prevState) => ({
      ...prevState,
      shouldTooltipOpen: visibility,
      text: visibility ? target?.innerText : '',
    }))
  }

  const handleToolTipClose = () => {
    setToolTipVisibilty((prevState) => ({
      ...prevState,
      shouldTooltipOpen: false,
    }))
  }

  const tableCellGrid = () => (
    <GridCell
      {...props}
      onMouseEnter={handleToolTipOpen}
      onMouseLeave={handleToolTipClose}
    >
      {children}
    </GridCell>
  )

  return showTabelCellWithTooltip ? (
    <Tooltip
      title={toolTipData?.text}
      arrow
      id="tableToolTip"
      componentsProps={{
        tooltip: {
          sx: toolTipCustomStyles,
        },
      }}
      open={toolTipData?.shouldTooltipOpen}
    >
      <div data-qa="admin-tableCellWithTooltip">{tableCellGrid()}</div>
    </Tooltip>
  ) : (
    tableCellGrid()
  )
}

export default memo(TableCellWithToolTip)
